import { chatStore } from '@/store/chatStore';
import { sendMsg } from '@/lib/websocket/index';
import { SocketMsgInterface } from '@/lib/typings';
import apiPath from '@/lib/apiPath';
import request from '@/lib/request';
import { setLoading, handleNotificationInstanceReplyed, showMsg, isWechatBrowser } from '@/lib/utils';
import {
  MSG_TYPE_STRING,
  MSG_TYPE,
  MSG_SEND_STATUS,
  MSG_TYPE_TEXT,
  sessionDispatchOptions,
  sessionDispatchOptionsMap,
  isSingapore,
} from '@/lib/const';
import { ElMessage } from 'element-plus';
import { rootStore } from '@/store/rootStore';
import bus from '@/lib/bus';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import { reportMonitorInfo } from './platform';

interface MsgInfo {
  type: number;
  text?: string;
  textWithAt?: string;
  img_url?: string;
  file_url?: string;
  title?: string;
  video_url?: string;
  voice_url?: string;
  voice_amr_url?: string;
  cover_url?: string;
  video_time?: number;
  voice_time?: number;
  applets_id?: number;
  time: number;
  content_id: string;
  internal?: boolean;
  session_id?: number;
  receive_id?: number;
  dispatch?: number;
  robot_id?: number;
}
export function sendUserMsg(info: MsgInfo) {
  const store = chatStore();
  const rootStoreEx = rootStore();
  sendMsg({
    type: 'SendUserMsg',
    data: Object.assign({}, info, {
      text: info.textWithAt || info.text,
      textWithAt: undefined,
      internal: store.isInternalMsg,
      session_id: info.session_id || store.currentChatRoomInfo?.sessionId,
      receive_id: info.receive_id || store.currentChatRoomInfo?.receiveId,
      dispatch: info.dispatch || sessionDispatchOptions[store.currentChatRoomInfo?.roomType],
      robot_id: info.robot_id || store.currentChatRoomInfo?.robotId || 0,
    }),
  });

  const time = String(info.time);
  store.updateSendingMsgQueue(MSG_SEND_STATUS['sending'], time);
  if (info.session_id == store.currentChatRoomInfo?.sessionId) {
    const currentUserInfo = rootStoreEx.currentUserInfo;
    const isInternal = rootStoreEx.currentCSInfo?.type == 1;
    store.updateCurrentChatRoomMsgList(
      [
        {
          data: {
            type: info.type,
            text: info.text,
            img_url: info.img_url,
            time: info.time,
            content_id: info.content_id,
            is_me: true,
            from_user: {
              type: 1,
              avatar_color: rootStoreEx.currentUserInfo?.avatar_color,
              nickname: isInternal
                ? currentUserInfo?.name?.split('-')[1]?.slice(0, 2) || currentUserInfo?.name?.slice(0, 2)
                : currentUserInfo?.name?.slice(0, 2),
            },
          },
          time,
          is_send_preview: true,
        },
      ],
      false,
      'push'
    );
  }
  // 关闭当前会话消息提醒框
  handleNotificationInstanceReplyed();
}
// 发送AI助手消息
export function sendAIUserMsg(info = {}, type: string = '') {
  const store = chatStore();
  sendMsg({
    type: 'AiAssistant',
    data: Object.assign({}, info, {
      action: 'SendMessage',
    }),
  });
  // 转发聊天记录 消息不做预览
  if (type !== 'history') {
    store.updateCurrentChatRoomAIMsgList(
      [
        {
          data: {
            type: MSG_TYPE['text'],
            text: info.text,
            time: info.time,
            content_id: info.content_id,
            is_me: false,
          },
          time: info.time,
        },
      ],
      false,
      'push'
    );
  }
}

// 发送营销心理-查询剩余次数
export function sendAIMarketInit(info = {}) {
  sendMsg({
    type: 'AiAssistant',
    data: Object.assign({}, info, {
      action: 'MarketInfo',
    }),
  });
}

export function sendEvaluation(info = {}) {
  const store = chatStore();
  sendMsg({
    type: 'Evaluation',
    data: info,
  });
  if (store.currentChatRoomInfo.roomType === 'h5') {
    store.updateCurrentChatRoomMsgList(
      [
        {
          data: {
            type: 'Evaluation',
            text: '已向用戶發起評價組件',
          },
        },
      ],
      false,
      'push'
    );
  }
}

export function sendNoticeUserOnline(info: any = {}) {
  if (!info.receive_id && !info?.receive_ids?.length) return;
  sendMsg({
    type: 'Notice',
    data: info,
  });
}

export function sendArchiveCollection(info: any = {}) {
  if (!info.receive_id) return;
  sendMsg({
    type: 'Business',
    data: info,
  });
}
// 发送IP升级服务
export function sendBusinessAddRessCollect(info: any = {}) {
  if (!info.receive_id || !info.up_robot_id) return;
  sendMsg({
    type: 'Business',
    data: info,
  });
}

export const accessSession = ({
  type = 'h5',
  receive_id = 0,
  group_id = 0,
  dispatch = 0,
  session_id = 0,
  rl = false,
}) => {
  const store = chatStore();
  const prev = store.currentChatRoomInfo;
  const prevReceiveId = prev?.receiveId || prev?.id;
  const prevSessionId = prev?.sessionId;
  const isSessionSwitch =
    (session_id && prevSessionId && Number(session_id) !== Number(prevSessionId)) ||
    (receive_id && prevReceiveId && Number(receive_id) !== Number(prevReceiveId));
  if (isSessionSwitch) {
    store.setCurrentChatRoomInfo({ isIntervene: false });
  }
  if (navigator?.onLine !== false) {
    store.setAccessSessionParams({
      session_id: session_id,
      receive_id: receive_id,
      group_id: group_id,
      time: dayjs().unix(),
    });
  }
  // 原先有接入会话的，接入新的之前要上报旧的会话 退出事件
  if (store.currentChatRoomInfo?.sessionId && !rl && !isWechatBrowser) {
    reportMonitorInfo('$ClientStataus', {
      $module: 'user_chatroom_out',
      $title: '客戶端用戶退出聊天室',
      $last_msg: store.currentChatRoomMsgList?.length
        ? JSON.stringify(store.currentChatRoomMsgList[store.currentChatRoomMsgList.length - 1]?.data)
        : '',
      sessionid: store.currentChatRoomInfo.sessionId,
      server_id: store.currentChatRoomInfo.receiveId,
    });
  }
  !rl &&
    reportMonitorInfo('$ClientStataus', {
      $module: 'user_chatroom_in',
      $title: '客戶端用戶進入聊天室',
      sessionid: session_id,
      server_id: receive_id,
    });
  return sendMsg({
    type: 'Access',
    data: {
      receive_id,
      group_id: group_id || undefined,
      // 1: h5/App 3: 群聊 4: 公号 5: 企微  6: 虚拟IP  7: 微信客服  8: 群聊
      dispatch: dispatch ? dispatch : sessionDispatchOptions[type],
      session_id,
      rl,
    },
  }).then(() => {
    // setLoading();
    const store = chatStore();
    if (store.currentChatRoomMsgList?.length) {
      store.clearCurrentChatRoomMsgList();
    }
  });
};

export const getChatMsgList = (prev_id: number = 0) => {
  const store = chatStore();
  if (prev_id === 0 && store.currentChatRoomMsgList?.length) {
    store.clearCurrentChatRoomMsgList();
  }
  // 个人接待获取聊天记录传 filter_word: true
  const filterWord = store.roomInfoCache?.roomFrom === 'personal' || undefined;
  sendMsg({
    type: 'ChatContent',
    data: {
      prev_id, //最后一条记录的id，第一次请求的时候为0
      filter_word: filterWord,
      receive_id: store.currentChatRoomInfo?.receiveId,
      session_id: store.currentChatRoomInfo?.sessionId,
    },
  });
};

/**
 * @param prev_id 前一条消息ID
 * @param source 0-命理命盘 1-营销心理
 */
export const getAIChatMsgList = ({ prev_id = 0, source = 0 }) => {
  const store = chatStore();
  if (prev_id === 0 && store.currentChatRoomAIMsgList?.length) {
    store.clearCurrentChatRoomAIMsgList();
  }
  sendMsg({
    type: 'AiAssistant',
    data: {
      action: 'ChatContent',
      prev_id,
      source,
    },
  });
};

export const endCurrentSession = () => {
  const store = chatStore();
  sendMsg({
    type: 'EndReceive',
    data: {
      dispatch: sessionDispatchOptions[store.currentChatRoomInfo?.roomType],
      receive_id: store.currentChatRoomInfo?.receiveId,
    },
  });
  store.clearCurrentChatRoomInfo();
};

export const recycleCurrentSessions = () => {
  const store = chatStore();
  sendMsg({
    type: 'RecyclePoolUser',
    data: {
      dispatch: sessionDispatchOptions[store.currentChatRoomInfo?.roomType],
      receive_id: store.currentChatRoomInfo?.receiveId,
    },
  });
};

export const transferSession = (to_uid: number) => {
  const chatStoreEx = chatStore();
  const rootStoreEx = rootStore();
  const { currentUserInfo } = rootStoreEx;
  if (currentUserInfo.id === to_uid) {
    return ElMessage.warning('不能轉接自己');
  }
  sendMsg({
    type: 'TransferReceive',
    data: {
      to_uid, // 客服uid
      dispatch: sessionDispatchOptions[chatStoreEx.currentChatRoomInfo?.roomType],
      receive_id: chatStoreEx.currentChatRoomInfo?.receiveId,
    },
  });
};

export const getSessionList = (groupType: string, page: number = 1) => {
  const store = chatStore();
  const rootStoreEx = rootStore();
  let api = calcMsgListApi(groupType);
  if (!api) return;
  if (
    (groupType === 'team' && rootStoreEx?.userMenu?.findIndex((v) => v.uri === 'teamChat') === -1) ||
    (['personal', 'robot'].includes(groupType) && rootStoreEx?.userMenu?.findIndex((v) => v.uri === 'chat') === -1)
  )
    return;
  request
    .get(api, {
      page,
    })
    .then((res: any) => {
      if (res.list) {
        res.list = handleSessionSort(res.list, groupType);
      }
      store.setChatList(groupType, res?.list || []);
    });
};
const msgListApi: { [p: string]: string } = {
  personal: apiPath.chat.getH5PersonalMsgList,
  team: apiPath.chat.getH5GroupMsgList,
  robot: apiPath.chat.getCSRobotReceiveList,
};
function calcMsgListApi(groupType: string) {
  return msgListApi[groupType];
}

export const annotateMessage = async (data: any) => {
  const type = data.subType;
  delete data.subType;
  const res = await request.post(apiPath.msg.bindMsg + `/${type}`, data);
  const id = res?.id;
  const extra = res?.extra;
  const store = chatStore();
  id && store.updateMsgListExtra(id, extra);
  bus.emit('updateUserDetailContent', type === 'order_id' ? 'order_id' : 'other');
};

export const getQuoteContentShow = (id?: string) => {
  if (id === '-1') {
    return '';
  }
  const chatStoreEx = chatStore();
  const { currentQuoteInfo } = chatStoreEx;
  const tmp = id || currentQuoteInfo.quoteMsgId;
  const msg = getMsgInfoById(tmp);
  return {
    type: currentQuoteInfo.msgType,
    content:
      currentQuoteInfo.msgType === 'text'
        ? msg?.data?.text
        : currentQuoteInfo.msgType === 'image'
          ? msg?.data?.img_url
          : MSG_TYPE_STRING[currentQuoteInfo.msgType],
  };
};

export const getMsgInfoById = (id: string) => {
  const chatStoreEx = chatStore();
  return (
    chatStoreEx.currentChatRoomMsgList.find((i: SocketMsgInterface) => String(i?.data?.id) === id) || {
      type: '',
      text: '',
    }
  );
};

export const getChatInfoById = (id: string, listFrom = 'personal') => {
  const chatStoreEx = chatStore();
  return chatStoreEx.currentChatList[listFrom]?.msgItems?.find((i: any) => String(i.id) === id) || {};
};

export const topMsg = (id: string | number, dispatch?: string) => {
  const chatStoreEx = chatStore();
  const roomType = calcListType(chatStoreEx.name);
  sendMsg({
    type: 'ReceiveSetTop',
    data: {
      id,
      dispatch: dispatch || roomType,
    },
  });
};

export const cancelTopMsg = (id: string | number, dispatch?: string) => {
  const chatStoreEx = chatStore();
  const roomType = calcListType(chatStoreEx.name);
  sendMsg({
    type: 'ReceiveRemoveTop',
    data: {
      id,
      dispatch: dispatch || roomType,
    },
  });
};

export const markMsg = (data: any) => {
  request
    .post(apiPath.chat.csSessionMark, {
      session_id: Number(data.session_id) || undefined,
      group_id: Number(data.group_id) || undefined,
      is_mark: !data.is_mark,
      receive_id: data.id,
    })
    .then(() => {
      showMsg(`${!data.is_mark ? '已標記' : '已取消標記'}`, 'success');
    });
};

export const tagMsg = (data: any) => {
  request.post(apiPath.chat.receiveLabelRelate, data).then(() => {
    const chatStoreEx = chatStore();
    ElMessage.success(`${data.relate_type == 'bind' ? '綁定' : '解綁'}成功`);
    if (data.receive_id === chatStoreEx.currentChatRoomInfo.receiveId) {
      const labels = chatStoreEx.currentChatRoomInfo.labels || [];
      const target = chatStoreEx.receiveLabelList?.find((v) => v.id === data.receive_label_id) || {};
      chatStoreEx.setCurrentChatRoomInfo({
        labels:
          data.relate_type === 'bind'
            ? [...labels, { id: target.id, name: target.name }]
            : labels?.filter((v) => v.id !== data.receive_label_id),
      });
    }
  });
};

export function getNotTopIndex(list: Array<any>) {
  return list.findIndex((i) => !i.is_top);
}

export function getChatListByListType(listFrom = 'personal') {
  const chatStoreEx = chatStore();
  const list = chatStoreEx.currentChatList || {};
  return list[listFrom]?.msgItems || [];
}

export function calcListTypeStr(source: number) {
  return sessionDispatchOptionsMap[source];
}

export function calcListType(name: string) {
  return sessionDispatchOptions[name];
}

export function addFavoritesFromMsg(msg: any, name: string = '') {
  // text-文本，image-图片，voice-音频，video-视频，image_text-图文，file-文件，applets-小程序
  const params = handleFavoritesParams(msg);
  return request
    .post(apiPath.favorites.favorites, {
      ...params,
      name,
    })
    .then(() => {
      ElMessage.success('收藏成功');
    });
}

export function dealQuickList(list: any) {
  return list.map((i: any) => {
    i.isParent = true;
    (Array.isArray(i.children) ? i.children : []).map((j: any) => {
      j.isParent = true;
      j.children = j.quick_reply;
      (Array.isArray(j.quick_reply) ? j.quick_reply : []).map((q: any) => {
        q.isContent = true;
        q.name = q.title;
        return q;
      });
      return j;
    });
    return i;
  });
}

export function flatQuickList(list: any) {
  let tmp: Array<any> = [];
  list.forEach((i: any) => {
    (Array.isArray(i.children) ? i.children : []).forEach((j: any) => {
      (Array.isArray(j.quick_reply) ? j.quick_reply : []).forEach((q: any) => {
        tmp.push(q);
      });
    });
  });
  return tmp;
}

export function recallMsg(id: Number | string) {
  const store = chatStore();
  ElMessage.info('撤回中');
  sendMsg({
    type: 'MessageReCall',
    data: {
      msg_id: Number(id),
      session_id: store.currentChatRoomInfo?.sessionId,
      receive_id: store.currentChatRoomInfo?.receiveId,
      dispatch: sessionDispatchOptions[store.currentChatRoomInfo?.roomType],
    },
  });
}

export function translateMsg(id: Number | string) {
  const store = chatStore();
  ElMessage.info('翻译中，請稍等');
  sendMsg({
    type: 'Translation',
    data: {
      id: Number(id),
      dispatch: sessionDispatchOptions[store.currentChatRoomInfo?.roomType],
    },
  });
}

export function translateCantoneseMsg(id: Number | string) {
  const store = chatStore();
  const targetMsg = store.currentChatRoomMsgList.find((i: any) => i.data.id == id);
  if (!targetMsg || !targetMsg.data.text) return;

  ElMessage.info('翻译中，請稍等');
  request
    .post(apiPath.chat.csTranslation, {
      receive_id: store.currentChatRoomInfo?.receiveId,
      text: targetMsg.data.text,
      source_language: 'yue',
      target_language: 'zh',
    })
    .then((res: any) => {
      ElMessage.success('翻译成功');
      store.updateMsgListTranslation(Number(id), res?.translated || '');
    })
    .catch(() => {
      ElMessage.error('翻译失败');
    });
}

export function toText(id: number) {
  const store = chatStore();
  ElMessage.info('轉换中，請稍等');
  sendMsg({
    type: 'AudioToText',
    data: {
      id: id,
      dispatch: sessionDispatchOptions[store.currentChatRoomInfo?.roomType],
    },
  });
}

function handleFavoritesParams(msg: any) {
  let type = msg.data.type;
  type = MSG_TYPE_TEXT[type];

  let favorites_data: any = {
    type,
  };
  if (type === 'text') {
    favorites_data = {
      ...favorites_data,
      text: {
        message: msg.data.text,
      },
    };
  } else if (type === 'image') {
    favorites_data = {
      ...favorites_data,
      image: {
        url: msg.data.img_url,
      },
    };
  } else if (type === 'voice') {
    favorites_data = {
      ...favorites_data,
      voice: {
        url: msg.data.voice_url,
        voice_time: msg.data.voice_time,
        voice_amr_url: msg.data.voice_amr_url,
      },
    };
  } else if (type === 'video') {
    favorites_data = {
      ...favorites_data,
      video: {
        url: msg.data.video_url,
        video_time: msg.data.video_time,
      },
    };
  } else if (type === 'file') {
    favorites_data = {
      ...favorites_data,
      file: {
        url: msg.data.file_url,
        title: msg.data.title,
      },
    };
  }
  return {
    type,
    favorites_data: JSON.stringify(favorites_data),
  };
}
// 订阅通知按钮事件
export function subscribeBtnClick(data: any) {
  return sendMsg({
    type: 'ClickEvent',
    data,
  });
}

// 会话标签列表
export function getReceiveLabelList(refresh = false) {
  const store = chatStore();
  if ((store.receiveLabelList?.length && !refresh) || !Cookies.get('IM-Token')) return;
  request.get(apiPath.chat.receiveLabel).then((res: any) => {
    store.setReceiveLabelList(res);
  });
}

// AI助手指令列表
export function getAiAssistantInstructionList() {
  if (isSingapore) return;
  const store = chatStore();
  if (store.aiAssistantInstruction?.length || isWechatBrowser) return;
  request.get(apiPath.chat.aiAssistantInstruction).then((res) => {
    if (res?.length) {
      store.setAiAssistantInstruction(res);
    }
  });
}

// 会话批量关闭
export const handlerBatchCloseSession = async (receive_ids = []) => {
  const chatStoreEx = chatStore();
  // 前端先去除这部分会话
  chatStoreEx.closeSessionByReceiveIds(receive_ids);
  chatStoreEx.setBatchCloseProgressInfo({
    release: receive_ids.length || 0,
    total: receive_ids.length || 0,
    failed_num: 0,
    show: true,
  });
  showMsg('正在關閉', 'success');
  // 每次100个会话进行关闭
  let arr = [];
  for (let i = 0; i < receive_ids.length; i = i + 100) {
    arr.push(receive_ids.slice(i, i + 100));
  }
  for (let i = 0; i < arr.length; i++) {
    await request
      .post(apiPath.chat.csBatchClose, {
        receive_ids: arr[i],
      })
      .catch(() => {
        chatStoreEx.closeSessionByReceiveIds(arr[i], true);
        chatStoreEx.setBatchCloseProgressInfo({
          failed_num: chatStoreEx.batchCloseProgressInfo?.failed_num + 100,
        });
      })
      .finally(() => {
        const realease = chatStoreEx.batchCloseProgressInfo?.release || 0;
        chatStoreEx.setBatchCloseProgressInfo({
          release: realease > 100 ? realease - 100 : 0,
          show: i !== arr.length - 1,
        });
        // 提示失败条数
        if (i === arr.length - 1 && chatStoreEx.batchCloseProgressInfo?.failed_num) {
          ElMessage.warning(`本次批量關閉共有${chatStoreEx.batchCloseProgressInfo?.failed_num}個會話關閉失敗`);
        }
      });
  }
};

// 会话排序
export const handleSessionSort = (list: any = [], listType = 'personal') => {
  if (!list.length) return [];
  const chatStoreEx = chatStore();
  if (chatStoreEx.messageSortType === 2 && listType === 'personal') {
    // 提醒部分
    const noticeList =
      list.filter((v) => v.user_notice_num)?.sort((a: any, b: any) => b?.created_at - a?.created_at) || [];
    // 未处理部分
    const unreadList =
      list
        .filter((v) => !v.user_notice_num && v.begin_wait_time)
        ?.sort((a: any, b: any) => b?.created_at - a?.created_at) || [];
    const otherList =
      list
        .filter((v) => !v.user_notice_num && !v.begin_wait_time)
        ?.sort((a: any, b: any) => b?.created_at - a?.created_at) || [];
    return [...noticeList, ...unreadList, ...otherList];
  } else {
    return list?.sort((a: any, b: any) => b?.created_at - a?.created_at) || [];
  }
};

// 获取当前接待参数
export const getCurrentSessionParams = () => {
  const store = chatStore();
  return {
    sessionId: store.currentChatRoomInfo?.sessionId,
    groupId: store.currentChatRoomInfo?.groupId,
    receiveId: store.currentChatRoomInfo?.receiveId,
    roomType: store.currentChatRoomInfo?.roomType,
    robotId: store.currentChatRoomInfo?.robotId,
    uid: store.currentChatRoomInfo?.uid,
    nickName: store.currentChatRoomInfo?.nickName,
  };
};
// 离开会话
export const quitAccess = () => {
  const store = chatStore();
  reportMonitorInfo('$ClientStataus', {
    $module: 'user_chatroom_out',
    $title: '客戶端用戶退出聊天室',
    $last_msg: store.currentChatRoomMsgList?.length
      ? JSON.stringify(store.currentChatRoomMsgList[store.currentChatRoomMsgList.length - 1]?.data)
      : '',
  });
  return sendMsg({
    type: 'Quit',
    data: {},
  });
};

// 收到消息确认
export const sendAck = (data: any) => {
  return sendMsg({
    type: 'Ack',
    data,
  });
};

// 上报
export const sendLog = (data: any) => {
  return sendMsg({
    type: 'Log',
    data,
  });
};

export const sendFavoriteMsg = (item) => {
  if (item.type === MSG_TYPE['text']) {
    sendUserMsg({
      type: MSG_TYPE['text'],
      text: item.favorites_data.text.message,
      time: dayjs().unix(),
      content_id: String(dayjs().valueOf()),
    });
  } else if (item.type === MSG_TYPE['image']) {
    sendUserMsg({
      type: MSG_TYPE['image'],
      img_url: item.favorites_data.image.url,
      time: dayjs().unix(),
      content_id: String(dayjs().valueOf()),
    });
  } else if (item.type === MSG_TYPE['voice']) {
    sendUserMsg({
      type: MSG_TYPE['voice'],
      voice_url: item.favorites_data.voice.url,
      voice_time: item.favorites_data.voice.voice_time,
      voice_amr_url: item.favorites_data.voice.voice_amr_url,
      time: dayjs().unix(),
      content_id: String(dayjs().valueOf()),
    });
  } else if (item.type === MSG_TYPE['video']) {
    sendUserMsg({
      type: MSG_TYPE['video'],
      video_url: item.favorites_data.video.url,
      video_time: Math.floor(Number(item.favorites_data.video.video_time)),
      time: dayjs().unix(),
      content_id: String(dayjs().valueOf()),
    });
  } else if (item.type === MSG_TYPE['file']) {
    sendUserMsg({
      type: MSG_TYPE['file'],
      file_url: item.favorites_data.file.url,
      title: item.favorites_data.file.title,
      time: dayjs().unix(),
      content_id: String(dayjs().valueOf()),
    });
  }
};

// 获取群聊接待ID，设置群聊最后一个接待ID（区分标签分组/默认）
export const handlerGroupReceiveInfo = (info = {}) => {
  return request.post(apiPath.group.wechatGroupReceiveId, info);
};

// 获取快捷回复列表
export const handlerGetQuickReplyList = () => {
  ElMessage.warning('快捷回復話術更新中...');
  const chatStoreEx = chatStore();
  chatStoreEx.setQuickReplyListLoading(true);
  request
    .get(apiPath.material.quickReplyOne)
    .then((res) => {
      Array.isArray(res.personal) && res.personal.forEach((i) => (i.isPersonal = true));
      Array.isArray(res.team) && res.team.forEach((i) => (i.isTeam = true));
      chatStoreEx.setQuickReplyList([...res.personal, ...res.team]);
      ElMessage.success('快捷回復話術更新成功');
    })
    .finally(() => {
      chatStoreEx.setQuickReplyListLoading(false);
    });
};
